import React, { useState } from 'react';
import './CopyButton.css';

const CopyButton = ({ text, label = 'Copier', className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      className={`copy-button ${copied ? 'copied' : ''} ${className}`}
      onClick={handleCopy}
      title={copied ? 'Copié !' : label}
    >
      {copied ? (
        <>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          <span>Copié !</span>
        </>
      ) : (
        <>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          <span>{label}</span>
        </>
      )}
    </button>
  );
};

// Prompt box with copy functionality
export const PromptBox = ({ children, prompt, title, className = '' }) => {
  // Support both 'prompt' prop and children
  const content = prompt || children || '';

  const textContent = typeof content === 'string'
    ? content
    : content?.props?.children || '';

  return (
    <div className={`prompt-box-container ${className}`}>
      {title && <div className="prompt-box-title">{title}</div>}
      <div className="prompt-box-content">
        <pre className="prompt-text">{textContent}</pre>
        <CopyButton text={textContent} label="Copier le prompt" />
      </div>
    </div>
  );
};

export default CopyButton;
